import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { Link, withRouter } from "react-router-dom";
import { Button, Card, Col, Row, Typography, message } from "antd";
import VHSpinner from "../../../../ui/VHSpinner";
import { isEmpty } from "lodash";
import ConfirmationDetails from "../ConfirmationDetails";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "../../../../ui/forms/StripeForm";

const STRIPE_CONNECTED_ACCOUNT_KEY = `${process.env.REACT_APP_STRIPE_CONNECTED_ACCOUNT_ID}`;
const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
const promise = loadStripe(STRIPE_KEY, {
	stripeAccount: STRIPE_CONNECTED_ACCOUNT_KEY,
});

@inject("context")
@withRouter
@observer
class RenewalsConfirm extends Component {
	state = {
		showCard: false,
		clientSecret: '',
	};

	componentDidMount() {
		const { insuranceRenewalsService, applicationService } = this.props.context;

		if (!isEmpty(insuranceRenewalsService.insuranceForRenewal)) {
			return;
		}

		if (applicationService.isAuthenticated) {
			this.props.history.push("/policies");
		} else {
			this.loadInsurance();
		}
	}

	clickShowCard = () => {
		const { insuranceRenewalsService } = this.props.context;
		const { clientData } = insuranceRenewalsService;
		this.sendPaymentIntent(clientData);
	};


	render() {

		const { insuranceRenewalsService } = this.props.context;
		const { showCard, clientSecret } = this.state;

		const insuranceForRenewal = insuranceRenewalsService.insuranceForRenewal;

		if (isEmpty(insuranceForRenewal)) {
			return <VHSpinner />;
		}

		const quoteForPayment = {
			total: insuranceRenewalsService.clientData.total,
			quoteId: insuranceRenewalsService.clientData.quoteId,
			stripePaymentPurpose: "RENEWAL",
			net_premium: insuranceRenewalsService.clientData.net_premium,
			new_premium: insuranceRenewalsService.clientData.new_premium,
			agent_commission: insuranceRenewalsService.clientData.agent_commission,
			agent_commission_rate: insuranceRenewalsService.clientData.agent_commission_rate,
			gross_premium: insuranceRenewalsService.clientData.gross_premium,
			admin_fee: insuranceRenewalsService.clientData.admin_fee,
			ipt_amt: insuranceRenewalsService.clientData.ipt_amt,
			totalDueRefund: 0,
			edited: false,
			isMtaPolicy: false,
		};

		const { policyNumber } = this.props.match.params;

		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Confirmation</h1>}>
							<Row>
								<Col xs={24} />
							</Row>
							<Row>
								<Col xs={24}>
									<ConfirmationDetails
										clientDataTitle={<Typography.Title level={4}>Your details</Typography.Title>}
										insuranceDataTitle={<Typography.Title level={4}>Your quote</Typography.Title>}
										clientData={insuranceForRenewal}
										insuranceData={insuranceForRenewal}
									/>
									<Row>
										<Col xs={24} className="d-flex" style={{ marginTop: "2rem" }}>
											<Button className="mr-auto">
												<Link to={`/renew/${policyNumber}`}>
													{insuranceRenewalsService.overThePhone
														? "Change details"
														: "<< My details have changed"}
												</Link>
											</Button>
											{!showCard && (
												<Button
													className="ml-auto"
													type="primary"
													onClick={this.clickShowCard}
												>
													{insuranceRenewalsService.overThePhone ? "Renew" : "Confirm"}
												</Button>
											)}
										</Col>
									</Row>
									<Row>
										<Col
											xs={24}
											className="d-flex"
											style={{ marginTop: "1rem", justifyContent: "center" }}
										>
											{showCard && (
												<Elements stripe={promise}>
													<StripeForm
														quoteForPayment={quoteForPayment}
														hidePostalCode={true}
														clientSecret={clientSecret}
													/>
												</Elements>
											)}
										</Col>
									</Row>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	loadInsurance = async () => {
		const { policyNumber } = this.props.match.params;
		const service = this.props.context.insuranceRenewalsService;

		if (!isEmpty(policyNumber)) {
			await service.loadInsuranceForRenewal(policyNumber);
			service.setClientData(service.insuranceForRenewal);
		} else {
			this.props.history.push("/");
		}
	};



	sendPaymentIntent = (quoteForPayment) => {



		const { insuranceRenewalsService } = this.props.context;

		const { insuranceForRenewal } = insuranceRenewalsService;


		const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;

		const amount = Math.round((insuranceForRenewal.total + Number.EPSILON) * 100);
		const paymentIntent = {
			amount,
			currency: "gbp",
			quoteId: quoteForPayment.quoteId,
			stripePaymentPurpose: "RENEWAL",
			net_premium: insuranceForRenewal.premium,
			new_premium: insuranceForRenewal.premiumAdjustment,
			agent_commission: insuranceForRenewal.agent_commission,
			agent_commission_rate: insuranceForRenewal.agent_commission_rate,
			gross_premium: insuranceForRenewal.gross_premium,
			admin_fee: insuranceForRenewal.admin_fee,
			ipt_amt: insuranceForRenewal.ipt_amt,
			totalDueRefund: insuranceForRenewal.totalDueRefund,
			edited: false,
			isMtaPolicy: false,
		};

		fetch(`${BASE_API_URL}/api/v1/payment-intent`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(paymentIntent),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data && typeof data.clientSecret === 'string') {
					this.setState({ clientSecret: data.clientSecret, showCard: true });
				} else {
					message.error("Failed to retrieve client secret. Please try again.");
				}
			})
			.catch((err) => {
				console.error("Error sending payment intent:", err);
				message.error("Failed to send payment intent. Please try again later.");
			});
	};
}

export default RenewalsConfirm;
